module.exports = __webpack_public_path__ + "static/media/fatherhood.f742c715.svg";